import React from 'react'

const Refund = () => {
  return (
    <div style={{ maxWidth: "900px", margin: "40px auto", padding: "20px", lineHeight: "1.7" }}>
      <h1>Refund & Cancellation Policy</h1>
      <p>Last Updated: 09/12/2025</p>

      <h2>1. Trial Period</h2>
      <p>
        Aamantran offers a 4-day free trial so users can fully experience the platform 
        before upgrading.
      </p>

      <h2>2. Paid Plan Refund Policy</h2>
      <p>
        Since digital access is instantly granted after payment, 
        <strong>we do not offer refunds</strong> after the upgrade is activated.
      </p>

      <h2>3. Exceptions</h2>
      <p>Refunds will be only considered if:</p>
      <ul>
        <li>You were charged but access was not activated</li>
        <li>A duplicate payment occurred</li>
        <li>Payment failed but amount was deducted</li>
      </ul>

      <h2>4. Refund Request Process</h2>
      <p>Email your payment receipt to:</p>
      <p><strong>aamantran0808@gmail.com</strong></p>
      <p>Refunds (if approved) are processed within 5–7 business days via Razorpay.</p>
    </div>
  )
}

export default Refund